import Vue from 'vue'
import App from './App.vue'
// import router from './router'
import store from './store'
import './config/gtm.js'
import './config/yandex.js'
import lodash from 'lodash'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import vmodal from 'vue-js-modal'
import VueWaypoint from 'vue-waypoint'
import VueTheMask from 'vue-the-mask'
import VeeValidate from 'vee-validate';
import VueAnimateNumber from 'vue-animate-number'
import vueTopprogress from 'vue-top-progress'
// import VueMouseParallax from 'vue-mouse-parallax'
import VueZoomer from 'vue-zoomer'
import Scrollspy from 'vue2-scrollspy';
import Ru_messages from 'vee-validate/dist/locale/ru';

import $ from 'jquery'
window.$ = window.jQuery = require('jquery');
window.axios = require('axios');
var VueScrollTo = require('vue-scrollto');
var ionRangeSlider = require('ion-rangeslider');

// config's for svgIcon 
import './plugins/svgIcon.js'
import '@/assets/icons'
// js libs
import 'bootstrap/dist/js/bootstrap.min.js'
import 'flickity-fade/flickity-fade.js'
import './plugins/sharer.js'
import 'selectric/public/jquery.selectric.min.js'
import '@/plugins/pinchzoomer/hammer.js'
import '@/plugins/pinchzoomer/TweenMax.js'
import '@/plugins/pinchzoomer/jquery.pinchzoomer.js'
// css libs
import 'swiper/dist/css/swiper.css'
import 'selectric/public/themes/plus/selectric.css'
import 'vue-zoomer/dist/vue-zoomer.css'
import 'ion-rangeslider/css/ion.rangeSlider.min.css'

window.body = $('body');
window.url = 'https://monaco.bazis.kz/cms/';
window.newsUrl = 'https://news.bazis.kz/cms/';
window.SalesURL = 'https://admin.sales.bazis.kz/';
window.CRMurl = 'https://bazis-online.kz/crmc';
window.JsonUrl = 'wp-json/acf/v3/';
window.host = 'monaco'; // dev var
window.GlobalLang = localStorage.getItem('language');

if (window.GlobalLang === null) {
  window.GlobalLang = '';
  setDataLang(window.GlobalLang);
} else if (window.GlobalLang === 'ru') {
  window.GlobalLang = '';
  setDataLang(window.GlobalLang);
} else {
  setDataLang(window.GlobalLang);
}

function setDataLang(lang) {
  if (lang = '') {
    document.querySelector('body').dataset.language = window.GlobalLang;
  } else {
    document.querySelector('body').dataset.language = window.GlobalLang.replace(/\/$/, "");
  }
}

const configVeeValidate = {
  aria: true,
  classNames: {},
  classes: false,
  delay: 0,
  dictionary: {
    ru: Ru_messages
  },
  errorBagName: 'errors', // change if property conflicts
  events: 'input|blur',
  fieldsBagName: 'fields',
  i18n: null, // the vue-i18n plugin instance
  i18nRootKey: 'validations', // the nested key under which the validation messages will be located
  inject: true,
  locale: 'ru',
  validity: false
};

const configScrollTo = {
  container: "body",
  duration: 1200,
  easing: "ease-in-out",
  force: true,
  cancelable: true,
  onStart: false,
  onDone: false,
  onCancel: false,
  x: false,
  y: true
};

Vue.use(VeeValidate, configVeeValidate);
Vue.use(VueScrollTo, configScrollTo);
Vue.use(VueZoomer);
Vue.use(vueTopprogress);
Vue.use(VueAnimateNumber);
Vue.use(VueTheMask);
Vue.use(VueAwesomeSwiper);
Vue.use(vmodal);
Vue.use(VueWaypoint);
Vue.use(Scrollspy);
Vue.use(lodash);
// Vue.use(VueMouseParallax);

new Vue({
  // router,
  render: h => h(App),
  store,
  mounted: () => document.dispatchEvent(new Event("x-app-rendered"))
}).$mount('#app')
